<template>
  <b-container>
    <config-publisher
      ref="configPublisher"
      v-model="config"
      tool-name="Connected Devices Menu Config"
      :config-name="configName"
      :can-edit="canCDMenuEdit"
      :can-publish="canCDMenuPublish"
      :is-form-valid="isFormValid">
      <c-d-menu-preview
        :config="config"
        class="my-3" />
      <c-d-menu-form
        ref="form"
        v-model="config"
        class="my-3" />
    </config-publisher>
  </b-container>
</template>

<script>
import ConfigPublisher from "@/components/ConfigPublisher"
import CDMenuForm from "@/components/CDMenu/CDMenuForm"
import {mapGetters} from "vuex"
import CDMenuPreview from "@/components/CDMenu/CDMenuPreview"

export default {
  name: "CDMenu",
  components: {
    CDMenuPreview,
    CDMenuForm,
    ConfigPublisher,
  },
  data: () => ({
    config: {},
    configName: "cdmenu",
  }),
  computed: {
    ...mapGetters([
      "canCDMenuEdit",
      "canCDMenuPublish",
    ]),
  },
  methods: {
    isFormValid() {
      return this.$refs.form.isValid()
    },
  },
  async beforeRouteLeave(to, from, next) {
    if (this.$refs.configPublisher.configHasChanged()) {
      const message = `You have unpublished changes to your config, which will be lost.\n\nClick "Cancel" to go back and publish your work, or click "Yes" to lose your changes.`
      next(await this.$confirm.open(message))
    } else {
      next()
    }
  },
}
</script>

<style scoped>

</style>
